(function () {
  'use strict';

  function initAboutHouseOfHolly(section) {
    if (!section || section.dataset.ahhInitialized === 'true') {
      return;
    }

    section.dataset.ahhInitialized = 'true';

    const image = section.querySelector('.about-house-of-holly__image');
    const button = section.querySelector('.about-house-of-holly__button');

    /*
     * Small accessibility enhancement:
     * If an image has no alt text, keep it decorative.
     */
    if (image && !image.getAttribute('alt')) {
      image.setAttribute('alt', '');
    }

    /*
     * Keyboard focus enhancement for the CTA.
     */
    if (button) {
      button.addEventListener('focus', function () {
        button.classList.add('is-focused');
      });

      button.addEventListener('blur', function () {
        button.classList.remove('is-focused');
      });
    }
  }

  function initAll() {
    document
      .querySelectorAll('.about-house-of-holly')
      .forEach(initAboutHouseOfHolly);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /*
   * Shopify Theme Editor support
   */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      const section = event.target.querySelector('.about-house-of-holly');

      if (section) {
        initAboutHouseOfHolly(section);
      }
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const section = event.target.querySelector('.about-house-of-holly');

    if (section) {
      section.dataset.ahhInitialized = 'false';
    }
  });
})();